import { generatePath, useHistory } from 'react-router-dom'
import {
  useNetworkHomeJobsRouteParams,
  useCurrentHomeSiteId,
  useSiteClientsCounts,
} from 'features/networkAi/hooks'
import ROUTES from 'app/routes'
import { useIntl } from 'react-intl'
import { makePublicUrl } from 'app/utils/publicUrl'
//import { useAppSelector } from 'app/hooks'
import { networkStatusClientsMessages } from './messages'
import {
  NetworkStatusClientsContainer,
  NetworkStatusClientsHeader,
  NetworkStatusClientsHeaderTitle,
  NetworkStatusClientsBody,
  NetworkStatusClientsItem,
  NetworkStatusClientsIcon,
  NetworkStatusClientsCount,
  NetworkStatusClientsCountLabel,
  NetworkStatusClientsForwardButton,
  NetworkStatusClientsForwardIcon,
} from './styles'

//import {siteClientsFetchDataSelector,} from 'features/networkAi/selectors'

function NetworkStatusClients() {
  const history = useHistory()
  const { rootDomainId, homeId, jobId } = useNetworkHomeJobsRouteParams()
  const siteId = useCurrentHomeSiteId({ homeId })
  const { formatMessage } = useIntl()
  const { wirelessTotal } = useSiteClientsCounts({ siteId })

  const handleNavigateClientsClick = () => {
    const pathname = generatePath(ROUTES.networkAi.dashboard.networkClients, {
      rootDomainId,
      jobId,
      homeId,
    })
    history.push(pathname)
  }

  return (
    <NetworkStatusClientsContainer>
      <NetworkStatusClientsHeader>
        <NetworkStatusClientsHeaderTitle>
          Network&nbsp;Clients
        </NetworkStatusClientsHeaderTitle>
        <NetworkStatusClientsForwardButton onClick={handleNavigateClientsClick}>
          <NetworkStatusClientsForwardIcon
            src={makePublicUrl(`images/networkIcons/arrow-forward.svg`)}
          />
        </NetworkStatusClientsForwardButton>
      </NetworkStatusClientsHeader>

      <NetworkStatusClientsBody>
        <NetworkStatusClientsItem>
          <NetworkStatusClientsCount>{wirelessTotal}</NetworkStatusClientsCount>
          <NetworkStatusClientsCountLabel>
            {formatMessage(networkStatusClientsMessages.wirelessTotalText)}
          </NetworkStatusClientsCountLabel>
        </NetworkStatusClientsItem>

        <NetworkStatusClientsItem>
          <NetworkStatusClientsIcon
            src={makePublicUrl(`images/networkIcons/device-hub.svg`)}
          />
        </NetworkStatusClientsItem>
      </NetworkStatusClientsBody>
    </NetworkStatusClientsContainer>
  )
}

export default NetworkStatusClients
